export default __webpack_public_path__ + "static/media/services_box.f04c4692.jpg";